module.exports = __webpack_public_path__ + "img/IMG_6102.3322850b.jpg";